module.exports = __webpack_public_path__ + "img/pop-up-back.ec35b34c.svg";